<template>
  <div class="page_admin_fields">
    <h1>Hřiště</h1>
    <div class="actions">
      <button @click="add" class="add" title="Přidat hřiště">
        <i class="fa fa-plus"></i>
      </button>
    </div>
    <tabloid name="fields" :columns="columns" :data="fields">
      <template v-slot:name="{ row }">
        <inputer :paths="['fields', row.id, 'name']" />
      </template>
      <template v-slot:x="{ row }">
        <inputerNumber :paths="['fields', row.id, 'x']" />
      </template>
      <template v-slot:y="{ row }">
        <inputerNumber :paths="['fields', row.id, 'y']" />
      </template>
      <template v-slot:width="{ row }">
        <inputerNumber :paths="['fields', row.id, 'width']" />
      </template>
      <template v-slot:height="{ row }">
        <inputerNumber :paths="['fields', row.id, 'height']" />
      </template>
      <template v-slot:rotation="{ row }">
        <inputerNumber :paths="['fields', row.id, 'rotation']" />
      </template>
      <template v-slot:actions="{ row }">
        <button @click="select($event, row)" class="select">Vybrat</button>
        <button @click="exportField(row)" class="export">Export</button>
        <button @click="remove(row)" class="remove"><i class="fa fa-times"></i></button>
      </template>
    </tabloid>
    <div class="map">
      <img src="map_fields.jpg" alt="mapa" width="1140" height="1280" />
      <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        viewBox="0 0 1140 1280"
        version="1.2"
        @click="move"
      >
        <g v-for="(field) in fields" :key="field.id" @click="select($event, field)">
          <rect :x="field.x" :y="field.y" :width="field.width" :height="field.height" :class="{ selected: selectedId == field.id }" :transform="`rotate(${field.rotation} ${field.x + field.width / 2} ${field.y + field.height / 2})`" />
          <text :x="field.x + field.width / 2" :y="field.y + field.height / 2" text-anchor="middle" dominant-baseline="middle">{{ field.name }}</text>
          <title>{{ field.name }}</title>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import { _, common } from "../../extend";
import { data } from "../../store_utils";
import tabloid from "../../components/tabloid.vue";
import inputer from "../../components/inputer.vue";
import inputerNumber from "../../components/inputer-number.vue";

export default {
  name: "admin_fields",
  components: {
    tabloid,
    inputer,
    inputerNumber,
  },
  data: () => ({
    columns: {
      name: { title: "Název" },
      x: { title: "Souřadnice X" },
      y: { title: "Souřadnice Y" },
      width: { title: "Šířka" },
      height: { title: "Výška" },
      rotation: { title: "Naklopení" },
      actions: { title: "" },
    },
    selectedId: null,
    bracketsToExport: {},
  }),
  computed: {
    fields() {
      return _.select(this.$store.state.fields, f => ({ 
        ...f, 
        rowAttributes: { class: { selected: f.id == this.selectedId }}
      }));
    }
  },
  methods: {
    add() {
      const id = data.newGuid();
      this.$store.commit("add", {
        paths: ["fields", id],
        value: {
          id: id,
          name: "",
          x: 500,
          y: 500,
          width: 50,
          height: 100,
          rotation: 0,
        }
      });
    },
    remove(field) {
      this.$store.commit("remove", {
        paths: ["fields", field.id]
      });
    },
    select(ev, field) {
      this.selectedId = field.id;

      ev.stopPropagation();
    },
    move(ev) {
      if (this.selectedId == null) {
        return;
      }

      this.$store.commit("update", {
        paths: ['fields', this.selectedId, 'x'],
        value: ev.offsetX,
      });
      this.$store.commit("update", {
        paths: ['fields', this.selectedId, 'y'],
        value: ev.offsetY,
      });
    },
    exportField(field) {
      this.$store.dispatch('exportTournamentPdf', { fieldId: field.id });
    },
  }
};
</script>

<style lang="sass">
@import ../../sass/_constants
@import ../../sass/_components

.page_admin_fields
  @include table-view()
  grid-template-areas: "label actions" "table table" "map map"
  grid-template-columns: auto 1fr
  grid-column-gap: 1rem

  h1
    grid-area: label
  .actions
    grid-area: actions
  table
    grid-area: table
    .selected
      background-color: $bc-primary
    td[data-columnname=actions]
      display: grid
      grid-auto-flow: column
      .select
        @include button-primary()
        @include first-input()
      .export
        @include button-secondary()
        @include middle-input()
      .remove
        @include button-danger()
        @include last-input()

  .map
    grid-area: map
    display: grid
    justify-content: center

    img, svg
      grid-column: 1
      grid-row: 1

    svg rect
      fill: $bc-warning
      &.selected
        fill: $bc-primary
</style>